'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _roles = require('config/permissions/roles');

var _company = require('./company.component');

var _company2 = _interopRequireDefault(_company);

var _companyAddForm = require('./company-add-form/company-add-form.module');

var _companyAddForm2 = _interopRequireDefault(_companyAddForm);

var _companyEditForm = require('./company-edit-form/company-edit-form.module');

var _companyEditForm2 = _interopRequireDefault(_companyEditForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('components.app.admin.company', [_angularUiRouter2.default, _companyAddForm2.default, _companyEditForm2.default]).component('company', _company2.default).config(function ($stateProvider) {
  'ngInject';

  $stateProvider.state('company', {
    parent: 'app',
    url: '/companies/{id:int}',
    component: 'company',
    data: {
      permissions: {
        only: [_roles.COMPANY_ADMIN, _roles.SYS_ADMIN],
        redirectTo: 'dashboard'
      }
    },
    resolve: {
      accessLevels: function accessLevels(AuthService) {
        return AuthService.getAccessLevels();
      },
      company: function company(CompanyService, $stateParams) {
        return CompanyService.getCompany($stateParams.id).then(function (r) {
          return r.data;
        });
      },
      user: function user(AccountService, AuthService, currentUser) {
        return AccountService.getAccount(currentUser.UserId).then(function (r) {
          return r.data;
        });
      },
      locked: function locked() {
        return true;
      }
    }
  });
}).name;


// WEBPACK FOOTER //
// ./components/app/admin/company/company.module.js